import { Urls, FeatureFlags, Toggles } from './keys';

export const defaults = {
  [Urls.Host]: 'www.autolist.com',
  [Urls.ApiBase]: 'https://production-proxy.autolist.com',
  [Urls.Amp]: 'amp.autolist.com',
  [Urls.AuthTokenGenerator]: 'https://campaigns.autolist.com/token',
  [Urls.EmailValidator]: 'https://www.autolist.com/api/email_validation',
  [Urls.PhoneValidator]: 'https://www.autolist.com/api/phone_check',
  [Urls.ComparisonsApi]:
    'https://3hpkht5dzk.execute-api.us-east-1.amazonaws.com/production/api/comparisons',
  [Urls.LookupApi]: 'https://www.autolist.com/api/lookup',
  [Urls.ContentApi]: 'https://g9ra0nyvkb.execute-api.us-east-1.amazonaws.com/production/api',
  [Urls.DealerPagesApi]:
    'https://yligh314xb.execute-api.us-east-1.amazonaws.com/production/api/dealer_pages',
  [FeatureFlags.Auth]: true,
  [Toggles.TestAds]: false,
  [Toggles.DebugEvents]: true,
};
